import { http } from '../../config/axios'

export default function patchCancelarBoletoFaturaService(id: string): Promise<string> {
  return http
    .patch('/api/fatura/cancelar-boleto/' + id)
    .then((r) => r.data)
    .catch((error) => {
      console.error('Erro ao cancelar boleto da fatura', error)
      throw Error(error.response?.data)
    })
}
